import { render, staticRenderFns } from "./CategoryDetailsAdmin.vue?vue&type=template&id=b99e09c2&"
import script from "./CategoryDetailsAdmin.vue?vue&type=script&lang=js&"
export * from "./CategoryDetailsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports